// fieldConfig.ts
import {
  TITLE,
  DATE,
  YEAR,
  DESCRIPTION,
  UPLOAD,
  RATING_TYPE,
  RATING_NAME,
  RATING_DESCRIPTION,
  THUMBNAIL_UPLOAD,
  UPLOAD_TRANSCRIPT,
  UPLOAD_LOGO,
  LINK,
} from "./consts";

export interface FieldConfig {
  fields: string[];
  additionalUpload: boolean;
  uploadAccept?: string;  // <-- ADD THIS
}


export const FIELD_CONFIGS: Record<string, FieldConfig> = {
  // ===== FINANCIALS & REPORTS =====
  
  // Investors Presentation & Press Release
  "Financials & Reports_Investors Presentation & Press Release_Press Release": {
    fields: [TITLE, DATE, YEAR, UPLOAD],
    additionalUpload: false
  },
  "Financials & Reports_Investors Presentation & Press Release_Investors Presentation": {
    fields: [TITLE, DATE, YEAR, UPLOAD],
    additionalUpload: false
  },

  // Quarterly Results
  "Financials & Reports_Quarterly Results_Quarterly Results": {
    fields: [TITLE, DATE, YEAR, UPLOAD],
    additionalUpload: false
  },

  // Annual Reports
  "Financials & Reports_Annual Reports_Annual Reports": {
    fields: [TITLE, DATE, YEAR],
    additionalUpload: true
  },

  // Annual Return
  "Financials & Reports_Annual Return_Annual Return": {
    fields: [TITLE, DATE, YEAR, UPLOAD],
    additionalUpload: false
  },

  "Financials & Reports_Webcast & Transcripts_Webcast & Transcripts": {
    fields: [TITLE, DATE, YEAR, UPLOAD, THUMBNAIL_UPLOAD, UPLOAD_TRANSCRIPT],
    additionalUpload: false,
    uploadAccept: "video/mp4"
  },

  // Credit Ratings
  "Financials & Reports_Credit Ratings_Credit Ratings": {
    fields: [TITLE, DATE, YEAR, UPLOAD, UPLOAD_LOGO, RATING_TYPE, RATING_NAME, RATING_DESCRIPTION],
    additionalUpload: false
  },

  // ===== GOVERNANCE & POLICIES =====

  // Policies & Code of Conduct
  "Governance & Policies_Policies & Code of Conduct_Policies & Code of Conduct": {
    fields: [TITLE, DATE, YEAR, UPLOAD],
    additionalUpload: false
  },

  // Corporate Governance
  "Governance & Policies_Corporate Governance_Corporate Governance": {
    fields: [TITLE, DATE, YEAR, UPLOAD],
    additionalUpload: false
  },

  // Advertisements in Newspapers as per Regulation 47(1)
  "Governance & Policies_Advertisements in Newspapers as per Regulation 47(1)_Advertisements in Newspapers as per Regulation 47(1)": {
    fields: [TITLE, DATE, YEAR, UPLOAD],
    additionalUpload: false
  },

  // Disclosure under Regulation 46 and 62 of SEBI (LODR)
  "Governance & Policies_Disclosure under Regulation 46 and 62 of SEBI (LODR)_Disclosure under Regulation 46 and 62 of SEBI (LODR)": {
    fields: [TITLE, DATE, YEAR, UPLOAD, LINK],
    additionalUpload: false
  },
  "Governance & Policies_Disclosure under Regulation 46 and 62 of SEBI (LODR)_Memorandum of Association and Articles of Association": {
    fields: [TITLE, DATE, YEAR, UPLOAD],
    additionalUpload: false
  },

  // Notices & Disclosures
  "Governance & Policies_Notices & Disclosures_Notices": {
    fields: [TITLE, DATE, YEAR, UPLOAD],
    additionalUpload: false
  },
  "Governance & Policies_Notices & Disclosures_Disclosure of Material Events": {
    fields: [TITLE, DATE, YEAR, UPLOAD],
    additionalUpload: false
  },

  // ===== SHAREHOLDERs INFORMATION =====

  // Related Party Transactions
  "Shareholders Information_Related Party Transactions_Related Party Transactions": {
    fields: [TITLE, DATE, YEAR, UPLOAD],
    additionalUpload: false
  },

  // Unclaimed Dividend
  "Shareholders Information_Unclaimed Dividend_Unclaimed Dividend": {
    fields: [TITLE, DATE, YEAR, UPLOAD],
    additionalUpload: false
  },

  // Shareholding Pattern
  "Shareholders Information_Shareholding Pattern_Shareholding Pattern": {
    fields: [TITLE, DATE, YEAR, UPLOAD],
    additionalUpload: false
  },

  // Secretarial Compliance Report
  "Shareholders Information_Secretarial Compliance Report_Secretarial Compliance Report": {
    fields: [TITLE, DATE, YEAR, UPLOAD],
    additionalUpload: false
  },
};

// Alternative configuration structure without underscores (optional)
export const FIELD_CONFIGS_STRUCTURED = {
  "Financials & Reports": {
    "Investors Presentation & Press Release": {
      "Press Release": {
        fields: [TITLE, DATE, YEAR, UPLOAD],
        additionalUpload: false
      },
      "Investors Presentation": {
        fields: [TITLE, DATE, YEAR, UPLOAD],
        additionalUpload: false
      }
    },
    "Quarterly Results": {
      "Quarterly Results": {
        fields: [TITLE, DATE, YEAR, UPLOAD],
        additionalUpload: false
      }
    },
    "Annual Reports": {
      "Annual Reports": {
        fields: [TITLE, DATE, YEAR],
        additionalUpload: true
      }
    },
    "Annual Return": {
      "Annual Return": {
        fields: [TITLE, DATE, YEAR, UPLOAD],
        additionalUpload: false
      }
    },
    "Webcast & Transcripts": {
      "Webcast & Transcripts": {
        fields: [TITLE, DATE, UPLOAD, UPLOAD_TRANSCRIPT],
        additionalUpload: false,
        uploadAccept: "video/mp4"
      }
    },
    "Credit Ratings": {
      "Credit Ratings": {
        fields: [TITLE, DATE, YEAR, UPLOAD, UPLOAD_LOGO, RATING_TYPE, RATING_NAME, RATING_DESCRIPTION],
        additionalUpload: false
      }
    }
  },
  "Governance & Policies": {
    "Policies & Code of Conduct": {
      "Policies & Code of Conduct": {
        fields: [TITLE, DATE, YEAR, UPLOAD],
        additionalUpload: false
      }
    },
    "Corporate Governance": {
      "Corporate Governance": {
        fields: [TITLE, DATE, YEAR, UPLOAD],
        additionalUpload: false
      }
    },
    "Advertisements in Newspapers as per Regulation 47(1)": {
      "Advertisements in Newspapers as per Regulation 47(1)": {
        fields: [TITLE, DATE, YEAR, UPLOAD],
        additionalUpload: false
      }
    },
    "Disclosure under Regulation 46 and 62 of SEBI (LODR)": {
      "Disclosure under Regulation 46 and 62 of SEBI (LODR)": {
        fields: [TITLE, DATE, YEAR, UPLOAD, LINK],
        additionalUpload: false
      },
      "Memorandum of Association and Articles of Association": {
        fields: [TITLE, DATE, YEAR, UPLOAD],
        additionalUpload: false
      }
    },
    "Notices & Disclosures": {
      "Notices": {
        fields: [TITLE, DATE, YEAR, UPLOAD],
        additionalUpload: false
      },
      "Disclosure of Material Events": {
        fields: [TITLE, DATE, YEAR, UPLOAD],
        additionalUpload: false
      }
    }
  },
  "Shareholder Information": {
    "Related Party Transactions": {
      "Related Party Transactions": {
        fields: [TITLE, DATE, YEAR, UPLOAD],
        additionalUpload: false
      }
    },
    "Unclaimed Dividend": {
      "Unclaimed Dividend": {
        fields: [TITLE, DATE, YEAR, UPLOAD],
        additionalUpload: false
      }
    },
    "Shareholding Pattern": {
      "Shareholding Pattern": {
        fields: [TITLE, DATE, YEAR, UPLOAD],
        additionalUpload: false
      }
    },
    "Secretarial Compliance Report": {
      "Secretarial Compliance Report": {
        fields: [TITLE, DATE, YEAR, UPLOAD],
        additionalUpload: false
      }
    }
  }
};

// Main function to get field configuration (using underscore approach)
export const getFieldConfig = (investorType: string, subType: string, type: string) => {
  const key = `${investorType}_${subType}_${type}`;
  return FIELD_CONFIGS[key as keyof typeof FIELD_CONFIGS];
};

// Alternative function using structured approach
export const getFieldConfigStructured = (investorType: string, subType: string, type: string) => {
  const categoryConfig = FIELD_CONFIGS_STRUCTURED[investorType as keyof typeof FIELD_CONFIGS_STRUCTURED];
  if (!categoryConfig) return null;

  const subTypeConfig = categoryConfig[subType as keyof typeof categoryConfig];
  if (!subTypeConfig) return null;

  return subTypeConfig[type as keyof typeof subTypeConfig] || null;
};

// Helper function to check if a field should be shown
export const shouldShowField = (fieldConfig: any, fieldName: string): boolean => {
  return fieldConfig?.fields?.includes(fieldName) || false;
};

// Helper function to check if additional upload is enabled
export const hasAdditionalUpload = (fieldConfig: any): boolean => {
  return fieldConfig?.additionalUpload || false;
};

// Get all possible field configurations for validation
export const getAllFieldConfigs = () => {
  return Object.values(FIELD_CONFIGS);
};

// Get required fields for a specific configuration
export const getRequiredFieldsForConfig = (investorType: string, subType: string, type: string): string[] => {
  const config = getFieldConfig(investorType, subType, type);
  return config?.fields || [];
};

// Field descriptions for tooltips or documentation
export const FIELD_DESCRIPTIONS = {
  [TITLE]: "Main title or name of the document",
  [DATE]: "Publication or effective date",
  [YEAR]: "Fiscal or calendar year reference",
  [DESCRIPTION]: "Detailed description or summary",
  [UPLOAD]: "Primary document file upload",
  [RATING_TYPE]: "Type of credit rating (e.g., Long-term, Short-term)",
  [RATING_NAME]: "Specific rating designation (e.g., AAA, A1+)",
  [RATING_DESCRIPTION]: "Explanation or details about the rating"
};

// Export field constants for easy access
export const FIELD_CONSTANTS = {
  TITLE,
  DATE,
  YEAR,
  DESCRIPTION,
  UPLOAD,
  RATING_TYPE,
  RATING_NAME,
  RATING_DESCRIPTION
};

export default FIELD_CONFIGS;